import { KeycloakService } from 'keycloak-angular';
import { SampleService } from '../Shared/Services/sample.service';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class KeyclockInit {
    kc: string;
    hostName;
    constructor(private sample: SampleService) {
        this.hostName = this.sample.getHostname();
        console.log('hostName :', this.hostName);
    }
    load() {
        for (let i = 0; i < environment.clients.length; i++) {
            if (this.hostName === environment.clients[i].url) {
                environment.api = environment.clients[i].api;
                environment.logo = environment.clients[i].logo;
                environment.header = environment.clients[i].header;
                environment.footer = environment.clients[i].footer;
                environment.kc = environment.clients[i].kc;
                environment.realm = environment.clients[i].realm;
                environment.kcUrl = environment.clients[i].kcUrl;
                environment.urlcrm = environment.clients[i].urlcrm;
                environment.urlbookbeds = environment.clients[i].urlbookbeds;
                environment.apiCheckinData = environment.clients[i].apiCheckinData;
                environment.urlAPIBookbeds = environment.clients[i].urlAPIBookbeds;
                console.log('API :', environment.api);
                console.log('header :', environment.clients[i].header);
            }
        }
    }
}

const PUBLIC_ROUTES = [
    '/pre-checkin/',
    '/pre-checkin',
    '/housemaid/reporting/',
    '/housemaid/reporting'
];

function isPublicRoute(): boolean {
    const currentPath = window.location.pathname;
    console.log('Current path:', currentPath);
    const isPublic = PUBLIC_ROUTES.some(route => currentPath.includes(route));
    console.log('Is public route:', isPublic);
    return isPublic;
}

export function initializeKeycloak(keycloak: KeycloakService, sampleService: SampleService) {
    return async () => {
        const keyClockInit = new KeyclockInit(sampleService);
        keyClockInit.load();

        if (isPublicRoute()) {
            console.log('Public route detected, minimal Keycloak initialization');
            try {
                // For public routes: don't check SSO at all, just initialize minimally
                await keycloak.init({
                    config: {
                        url: environment.kcUrl,
                        realm: environment.realm,
                        clientId: environment.kc,
                    },
                    initOptions: {
                        // Key change: no onLoad at all - don't check SSO
                        checkLoginIframe: false,
                    },
                    enableBearerInterceptor: false,
                    bearerExcludedUrls: [],
                });
                console.log('Keycloak initialized for public route');
                return true;
            } catch (error) {
                console.warn('Keycloak init failed for public route, continuing anyway:', error);
                // For public routes, we don't care if Keycloak fails
                return true;
            }
        }

        // Normal initialization for protected routes
        return keycloak.init({
            config: {
                url: environment.kcUrl,
                realm: environment.realm,
                clientId: environment.kc,
            },
            initOptions: {
                checkLoginIframe: false,
                checkLoginIframeInterval: 25,
                onLoad: 'check-sso',
                silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
            },
            enableBearerInterceptor: true,
            bearerExcludedUrls: [
                '/housemaid/reporting',
                '/pre-checkin'
            ],
        });
    };
}